import styled from 'styled-components';

export const SlideMobileAccountStateStyledContainer = styled.div`
    background: #8192E40D;
    border-radius: 16px;
`;

export const SlideMobileAccountStateItemStyled = styled.div`
    display: flex;
    justify-content: space-between;

    padding: 16px;

    &:not(:last-child) {
        border: 1px solid var(--color-base-secondary);
    }

    span:first-child {
        color: #FFFFFF99;
        font-size: 14px;
    }
    span:last-child {
        color: var(--color-white);
        font-size: 16px;
    }
`;
